<script lang="ts">
    import HtmlForm from '$components/Form/HtmlForm.svelte';
    import Row from '$components/Form/Row.svelte';
    import Input from '$components/Form/Input.svelte';
    import { createForm } from '$components/LoginForm/LoginFormData.js';
    import { createOnSubmit } from '$components/LoginForm/LoginFormAction.js';
    import SubmitButton from '$components/Form/SubmitButton.svelte';
    import FormErrors from '$components/Form/FormErrors.svelte';
    import PasswordInput from '$components/Form/PasswordInput.svelte';
    import { getContainer } from '$components/Context/ContainerContext';
    import * as t from '$trans';

    let [form, fields] = createForm('login-form-dropdown', {});

    export let onSubmit = createOnSubmit({ targetPath: () => null });
    const { urlHelper, lang } = getContainer();
</script>

<div class="p-[24px] flex flex-col gap-y-[24px] w-full ls:w-[350px]">
    <div class="text-22/[120%] font-bold">{t.login.to_login({}, $lang)}</div>

    <div class="w-full">
        <HtmlForm class="flex flex-col gap-y-[16px]" {form} {onSubmit}>
            <Row {form} field={fields.email} label="Email" let:field>
                <Input
                    {form}
                    {field}
                    autofocus={true}
                    toText={(id) => id}
                    fromText={(id) => id}
                    name="email"
                />
            </Row>

            <Row {form} field={fields.password} label="Mot de passe" let:field>
                <PasswordInput {form} {field} name="password" />
            </Row>

            <FormErrors {form} />

            <div class="flex flex-col gap-1">
                <SubmitButton
                    {form}
                    class="btn-leo btn-leo-primary btn-xl"
                    text="Se connecter"
                    submittingText="Connexion en cours..."
                />

                <a
                    class="text-12 text-link underline hover:no-underline py-[4px] self-end"
                    href={urlHelper().resetPassword()}>Mot de passe oublié ?</a
                >
            </div>
        </HtmlForm>
    </div>

    <div
        class="bg-gray-350 p-[16px] flex flex-col text-center rounded-[8px] gap-y-[4px] relative"
    >
        <strong class="text-16/[120%] font-bold"
            >{t.login.new_on_goafrica({}, $lang)}</strong
        >

        <a
            class="text-link underline hover:no-underline focus:underline text-14 font-medium stretched-link"
            href={urlHelper().registration()}
            data-sveltekit-reload={false}
        >
            {t.login.register_for_free({}, $lang)}
        </a>
    </div>
</div>
